import { render, staticRenderFns } from "./ManifestBlock.vue?vue&type=template&id=fad26e36&scoped=true"
import script from "./ManifestBlock.vue?vue&type=script&lang=ts"
export * from "./ManifestBlock.vue?vue&type=script&lang=ts"
import style0 from "./ManifestBlock.vue?vue&type=style&index=0&id=fad26e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad26e36",
  null
  
)

export default component.exports